<script lang="ts" setup>
	import { useAuthStore } from '@/store/auth.store';
	import { useModalStore } from '@/store/modal.store';
	import { ref, onMounted, onUnmounted } from 'vue';

	const authStore = useAuthStore();
	const modalStore = useModalStore();

	const isMobile = ref(false);

const handleResize = () => {
	isMobile.value = window.innerWidth < 992;
};

onMounted(() => {
	handleResize();
	window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
	window.removeEventListener("resize", handleResize);
});

let changeViewport = '';

onMounted(() => {
const viewportMeta = document.querySelector('meta[name="viewport"]');
if (viewportMeta) {
	changeViewport = viewportMeta.getAttribute('content') || '';
	viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no');
}
});

const openModal = (modal: string) => {
	modalStore.openModal(modal);
};

</script>

<template>
	<div  v-if="!isMobile">
		<div class="bartop">
			<div class="bartop__logo">
				<img src="@/assets/img/leftbar__logo.svg" alt="">
			</div>

			<ul class="topbar__nav">
				<li>
					<router-link :to="'/my-account'" >
						My Account
					</router-link>
				</li>
				<li>
					<router-link :to="'/my-devices'" >
						Devices
					</router-link>
				</li>
				<li>
					<router-link :to="'/contact-us'" >
						Contact Us
					</router-link>
				</li>
			</ul>

			<div class="topbar__actions">
				<button class="add-device-btn" @click="openModal('AddNewDevice')">
					<span class="material-symbols-outlined">add</span>
					<span>Add Device</span>
				</button>
				
				<div class="topbar__out" @click="authStore.logOut()">
					<span class="material-symbols-outlined login__item_ico">logout</span>
					<span class="topbar__out-text">Log out</span>
				</div>
			</div>

		</div>
	</div>

	<div v-else>

		<div  class="bartop">
			<div class="bartop__logo">
				<img src="@/assets/img/logo__white.svg" alt="">
			</div>

			<div class="topbar__out" @click="authStore.logOut()">
				<span class="material-symbols-outlined login__item_ico">logout</span>
				<span class="topbar__out-text"></span>
			</div>
		</div>

		<div class="barbot">
			
			<ul class="topbar__nav">
				<li>
					<router-link :to="'/my-account'" >
						My Account
					</router-link>
				</li>
				<li>
					<router-link :to="'/my-devices'" >
						Devices
					</router-link>
				</li>
				<li>
					<router-link :to="'/contact-us'" >
						Contact Us
					</router-link>
				</li>
			</ul>
		</div>
	</div>
	
</template>


<style lang="scss" scoped>
	.topbar {
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100vw;
		padding: 15px 30px 15px 100px;
		background: #fff;
		box-shadow: 29px 7px 45px rgba(0, 0, 0, 0.05);
		z-index: 100;
		transition: all .6s;
	}
	.bartop{
		padding: 18px 20px; 
		display: flex;
		align-items: center;
		justify-content: space-between;
		
	}
	.bartop a{
		color: #0F172A;
	}
	.bartop__logo{
		width: 185px;
		height: 50px;
	}
	.bartop__logo img{
		width: 100%;
		height: auto;
	}

	.topbar__nav{
		display: flex;
		justify-content: center;
		gap: 40px;
	}
	.topbar__nav li{
		position: relative;
	}

	.topbar__nav .router-link-active{
		color: #2563EB;
	}
	.topbar__nav .router-link-active:before{
		opacity: 1;
	}
	.topbar__nav a{
		transition: all .6s;
		color: #0F172A;
		font-size: 16px;
		font-weight: 600;
	}
	.topbar__nav a:hover{
		color: #2563EB;
	}
	.topbar__nav a:before{
		position: absolute;
		content: '';
		background: #2563EB;
		left: 50%;
		bottom: -10px;
		transform: translate(-50% , 0);
		width: 100%;
		height: 4px;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px; 
		opacity: 0;
		transition: all .6s;
	}
	.topbar__nav a:hover::before {
    opacity: 1;
	}

	.topbar__actions {
		display: flex;
		align-items: center;
		gap: 15px;
	}
	
	.add-device-btn {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 8px 16px;
		background: #2563eb;
		color: white;
		border: none;
		border-radius: 6px;
		font-size: 14px;
		font-weight: 600;
		cursor: pointer;
		transition: background-color 0.2s;
	}
	
	.add-device-btn:hover {
		background: #1d4ed8;
	}
	
	.add-device-btn .material-symbols-outlined {
		font-size: 18px;
	}
	
	.topbar__out{
		position: relative;
		display: flex;
		align-items: center;
		cursor: pointer;
	}
	.topbar__out-text {
		display: block;
		padding-left: 50px;
	}
	.login__item_ico {
		top: 50%;
	}

	.barbot{
		position: fixed;
		width: 100%;
		bottom: 20px;
		padding: 20px;
		z-index: 1111;
	}

	@media (max-width: 992px) {
		.bartop{
			position: absolute;
			top: 0;
			left: 0;
			z-index: 11;
			right: 0;
		
		}
		.topbar__nav .router-link-active{
			color: #fff !important;
		}
		.topbar__nav{
			display: flex;
			justify-content: space-around;
		}
		.topbar__out{
			color: #fff;
		}
		.login__item_ico{
			color: #fff;
		}
		.topbar__nav a{
			color: #fff;
			font-size: 14px;
			font-weight: 500;
		}
		.topbar__nav a:before{
			background: #fff;
		}
		.topbar__nav .router-link-active{
			color: #fff;
		}
	}
</style>